import React, {Component} from "react";
import InstancesListViewRow from "./InstancesListViewRow";
import "./InstancesListView.css"

export default class InstancesListView extends Component {

    render() {
        return (
            <div>
                <table className={"instances-table"} data-testid="instances.table">
                    <thead>
                    <tr className={"instances-table-row"} data-testid="instances.table.headerRow">
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.type">Type</th>
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.domain">Domain</th>
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.email">Email</th>
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.startDate">Start Date</th>
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.URL">URL</th>
                        <th className={"instances-table-header-cell"} data-testid="instances.table.headerCell.status">Status</th>
                    </tr>
                    </thead>
                    {this.props.pisaasInstances.map((instance, index) => {
                        return (
                            <InstancesListViewRow instance={instance} key={index}/>
                        )
                    })}
                </table>

            </div>
        );
    }
}